
































































































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { GenplanModalData, GenplanProps, Housing } from './types';
import Picture from '@/components/Picture/Picture.vue';
import Button from '@/components/Controls/Button/Button.vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import Spinner from '@/components/Spinner/Spinner.vue';
import GenplanModalLinkItem from './GenplanModalLinkItem.vue';
import Modal, { ModalLinePrimary, ModalLineSecondary } from '@/components/Modal';
import { http } from '@/http';

@Component({
    components: {
        Picture,
        Button,
        Modal,
        ModalLinePrimary,
        ModalLineSecondary,
        SvgIcon,
        GenplanModalLinkItem,
        Spinner,
    },
})
export default class Genplan extends Vue implements GenplanProps {
    /**
     *
     */
    @Prop()
    public readonly housingFetchUrl!: string;
    /**
     *
     */
    @Prop({ default: '/images/genplan/1920x960.jpg' })
    public readonly bigPictureUrl!: string;
    /**
     *
     */
    @Prop({ default: '/images/genplan/1920x960-thumb.jpg' })
    public readonly smallPictureUrl!: string;
    /**
     *
     */
    @Ref()
    public readonly buttonsLayer!: HTMLElement;
    /**
     *
     */
    @Ref()
    public readonly wrapper!: HTMLElement;
    /**
     *
     */
    public housingList: Housing[] = [];
    /**
     *
     */
    public debug: boolean = false;
    /**
     *
     */
    public xMin: number = 0;
    /**
     *
     */
    public xMax: number = 0;
    /**
     *
     */
    public yMin: number = 0;
    /**
     *
     */
    public yMax: number = 0;
    /**
     *
     */
    public xCenter: number = 0;
    /**
     *
     */
    public yCenter: number = 0;
    /**
     *
     */
    public showModal: boolean = false;
    /**
     *
     */
    public modalData: GenplanModalData = {} as GenplanModalData;
    /**
     *
     */
    public modalDataCache: any = {};
    /**
     *
     */
    public buttons: HTMLElement[] = [];
    /**
     *
     */
    public async fetchHousingList() {
        this.$wait.start('fetch-housing-list');

        try {
            const { data: housingList } = await http.get<Housing[]>(this.housingFetchUrl);
            this.housingList = housingList;
        } catch (error) {
            this.$errorLog(error);
        }

        this.$wait.end('fetch-housing-list');
    }
    /**
     *
     */
    public getModalKindergarten() {
        const modalData: GenplanModalData = {
            plainText: {
                linePrimary: 'Детский сад',
                lineSecondary:
                    '<p>Срок сдачи: II квартал 2022 г.<br>Количество мест: 250</p>',
            },
        };

        this.getModal(modalData);
    }
    /**
     *
     */
    public getModal(modalData: GenplanModalData) {
        this.modalData = modalData;
        this.showModal = true;
    }
    /**
     *
     */
    public closeModal() {
        this.modalData = {} as GenplanModalData;
        this.showModal = false;
    }
    /**
     *
     */
    public getButtonPosition(housing: Housing) {
        const { top, left } = housing.buttonPosition || {};

        return {
            top: top ? top + '%' : null,
            left: left ? left + '%' : null,
        };
    }
    /**
     *
     */
    public collectButtons() {
        const buttonElms = this.buttonsLayer.querySelectorAll<HTMLElement>(
            '.genplan__btn'
        );

        this.buttons = [...buttonElms];
    }
    /**
     *
     */
    public getButtonsBoundary() {
        return this.buttons.reduce(
            (prev, curr) => {
                const currXMin = curr.offsetLeft;
                const currXMax = curr.offsetLeft + curr.offsetWidth;
                const currYMin = curr.offsetTop;
                const currYMax = curr.offsetTop + curr.offsetHeight;

                if (currXMin < prev.xMin || prev.xMin == null) {
                    prev.xMin = currXMin;
                }

                if (currXMax > prev.xMax || prev.xMax == null) {
                    prev.xMax = currXMax;
                }

                if (currYMin < prev.yMin || prev.yMin == null) {
                    prev.yMin = currYMin;
                }

                if (currYMax > prev.yMax || prev.yMax == null) {
                    prev.yMax = currYMax;
                }

                return prev;
            },
            ({
                xMin: null,
                xMax: null,
                yMin: null,
                yMax: null,
            } as unknown) as {
                xMin: number;
                xMax: number;
                yMin: number;
                yMax: number;
            }
        );
    }
    /**
     *
     */
    public setScrollPosition() {
        const { xMin, xMax, yMin, yMax } = this.getButtonsBoundary();
        this.xMin = xMin;
        this.xMax = xMax;
        this.yMin = yMin;
        this.yMax = yMax;
        this.xCenter = xMin + (xMax - xMin) / 2;
        this.yCenter = yMin + (yMax - yMin) / 2;
        const scrollPosition = Math.ceil(this.xCenter - this.wrapper.clientWidth / 2);
        this.wrapper.scrollTo(scrollPosition, 0);
    }
    /**
     *
     */
    public onResize() {
        this.setScrollPosition();
    }
    /**
     *
     */
    public beforeDestroy() {
        if (this.debug) {
            window.removeEventListener('resize', this.onResize);
        }
    }
    /**
     *
     */
    public async mounted() {
        await this.fetchHousingList();
        await this.$nextTick();
        this.collectButtons();
        this.setScrollPosition();

        if (this.debug) {
            window.addEventListener('resize', this.onResize);
        }
    }
}
